export default "__VITE_ASSET__DLJPRFhI__"